import React, { useState } from "react";
import { FaFacebook, FaGoogle } from "react-icons/fa";
import { Caption, Container, PrimaryButton, Title } from "../../router";
import { commonClassNameOfInput } from "../../components/common/Design";
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export const TwoFa = () => {
  const navigate = useNavigate(); 
  const [code, setCode] = useState('')
 
const onChange = async (e) => {
    setCode(e.target.value)
}
const handleSubmit = async (e) => {
    e.preventDefault();
   
    
    //alert(process.env.REACT_APP_API_URL)
    if (code =='' ) {
      toast.error("Cannot log in to the system. OTP is empty. Please check and try again", { theme: 'colored' })
   }
   else{
    toast.warning("Please wait, processing your credentials.", {theme: 'colored'});
    const requestBody = {
      code: code,
      email: localStorage.getItem('email')
  }
  const hed ={
    headers:{
     authorization:`Bearer ${localStorage.getItem('token')}`

    }
  }
  let responseData = await axios.post(`${process.env.REACT_APP_API_URL}verify-otp`, requestBody,hed).then(response => {
      console.log(response)
       localStorage.setItem("_id", "253876F1A")
      toast.success("Login Successfully", { theme: 'colored' })
     window.location.href = `${process.env.REACT_APP_BASE_URL}dashboard`;
  
  
  }).catch(error => {
      console.log(error)
       if (error.response.status === 400 || error.response.status === 403) {
          toast.error(error.response.data.status, { theme: 'colored' })
      } else {
          toast.error("sorry... the backend server is down!! please try again later", { theme: 'colored' })
      }
  })
}  
 

}
  return (
    <>
      <section className="relative pt-16 regsiter">
        <div className="absolute rounded-full bg-green w-96 h-96 opacity-20 blur-3xl top-2/3"></div>
         <form className="w-1/3 p-8 m-auto my-16 bg-white shadow-s3 rounded-xl">
          <div className="text-center">
            <Title level={5}>Please enter your correct incoming OTP code</Title>
          </div> 

          <div className="py-5 mt-8">
            <Caption className="mb-2">Enter your OTP code</Caption>
            <input type="email" name="email" className={commonClassNameOfInput} placeholder="Enter OTP" required  onChange={onChange}
                                value={code} />
          </div>
         
          <button type="submit" onClick={handleSubmit} className='w-full px-16 py-3 my-5 text-lg font-medium text-white transition ease-in-out rounded-none rounded-full bg-green hover:bg-primary' >
          VERIFY
         </button>
          
        </form>
        <div className="absolute right-0 rounded-full bg-green w-96 h-96 opacity-20 blur-3xl bottom-96"></div>
      </section>
      <ToastContainer/>
    </>
  );
};
